import styled, { css } from 'styled-components'

import { Select as BoltSelect, Input as BoltInput } from '@sainsburys-tech/bolt'

export const DeliveryEmail = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  border-radius: ${props => props.theme.size.border.radius.lg};
  background-color: ${props => props.theme.color.semantic.info.lighter};
`

export const Heading = styled.div`
  display: flex;
  margin-bottom: 10px;
  font-weight: ${props => props.theme.font.weight.bold};
  color: ${props => props.theme.color.palette['blue-60']};

  svg {
    fill: currentColor;
    margin-right: 10px;
  }
`

export const Copy = styled.div`
  margin-bottom: 10px;
`

export const Select = styled(BoltSelect)`
  ${props =>
    props.error &&
    css`
      select {
        border-width: ${props.theme.size.border.width.md};
      }
    `}
  span {
    margin-bottom: 7px;
  }
`

// FORM STYLING
// Stacked: Form elements placed vertically
// Inline: Form elements placed horizontally
const stackedForm = css`
  flex-direction: column;
  align-items: flex-start;
`

const stackedSelect = css`
  margin: 0 0 10px 0;
  width: 100%;
`

const inlineForm = css`
  flex-direction: row;
  align-items: flex-end;
`

const inlineSelect = css`
  margin: 0 15px 0 0;
  width: 180px;
`

export const Form = styled.form`
  display: flex;
  ${stackedForm}

  > ${Select} {
      ${stackedSelect}
    }

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].sm}) {
    ${inlineForm}

    > ${Select} {
      ${inlineSelect}
    }
  }

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    ${stackedForm}

    > ${Select} {
      ${stackedSelect}}
    }
  }

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].xl}) {
    ${inlineForm}

    > ${Select} {
      ${inlineSelect}
    }
  }
`

export const Input = styled(BoltInput)`
  margin-bottom: 0;

  input {
    &:hover,
    &:active,
    &:focus,
    & {
      ${props =>
        props.isV2 &&
        css`
          border-radius: 8px 0 0 8px !important;
        `}
    }
  }

  button {
    background-color: ${props => props.theme.color.monochrome.white};
    ${props =>
      props.isV2 &&
      css`
        border-radius: 0 8px 8px 0;
      `}
  }
`
